import React from "react";
import { createRoot  } from "react-dom/client";
import "./assets/Css/style.css";
import "./assets/Css/animate.min.css";
import "./assets/Css/bootstrap.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store/store";



const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
    <Provider store={store}>
    <App  />
    </Provider>
);
